import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useFormikContext } from "formik";
import { isNumber, isEmpty } from "lodash";
import { API_STATUSES } from "../..";
import { UserListContext } from "../../../../../../context/follow-up-widgets";

const PaginationView = () => {
  const { values, submitForm, setFieldValue } = useFormikContext();
  const { results, responseStatus } = useContext(UserListContext);

  const startIndex = (values.pageNumber - 1) * values.pageSize + 1;
  const endIndex = values.pageNumber * results.length;

  return (
    !isEmpty(results) &&
    responseStatus === API_STATUSES.SUCCESS && (
      <Grid container direction="row" className="pagination-view">
        <Typography variant="body2" className="left-pagination-text">
          {`Showing ${startIndex} - ${endIndex} out of ${values.totalResults} results`}
        </Typography>

        <Pagination
          page={isNumber(values.pageNumber) && values.pageNumber}
          count={values.pageCount}
          onChange={(e, page) => {
            setFieldValue("pageNumber", page);
            submitForm();
          }}
        />
      </Grid>
    )
  );
};

export default PaginationView;
